import actionTypes from './actions/actionTypes'

const {
  REQUEST_LOGIN,
  RECEIVE_LOGIN_STATUS,
  AUTH_ERRORS,
  FORET_PASS_ERROR,
  RESET_PASSWORD,
  SET_SHOULD_RESET,
  LOGIN_STATUS
} = actionTypes

const loginReducer = (state = {
  isLoggingIn: false,
  loginStatus: false,
  user: {},
  hasErrorOccured: false,
  errors: null,
  forgetPassError: false,
  shouldResetPassword: false,
  isLoggedIn: false
}, action) => {
  switch (action.type) {
    case REQUEST_LOGIN:
      return Object.assign({}, state, {
        isLoggingIn: true,
        hasErrorOccured: true
      })
    case AUTH_ERRORS:
      return Object.assign({}, state, {
        hasErrorOccured: true,
        errors: action.errors
      })
    case FORET_PASS_ERROR:
      return Object.assign({}, state, {
        forgetPassError: true
      })
    case SET_SHOULD_RESET:
      return Object.assign({}, state, {
        shouldResetPassword: action.shouldResetPassword
      })
    case RESET_PASSWORD:
      return Object.assign({}, state, {
        forgetPassError: false,
        shouldResetPassword: true
      })
    case LOGIN_STATUS:
      return Object.assign({}, state, {
        isLoggedIn: action.isLoggedIn
      })
    case RECEIVE_LOGIN_STATUS:
      return Object.assign({}, state, {
        isLoggingIn: false,
        loginStatus: action.success,
        user: action.user,
        hasErrorOccured: true,
        logoutSuccess: false
      })
    default:
      return state
  }
}

export default loginReducer



// WEBPACK FOOTER //
// ./src/routes/Login/reducer.js